import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

export function PageTitle({
  title,
  subtitle,
  action,
}: {
  title: string
  subtitle: string
  action?: ReactNode
}) {
  const location = useLocation()

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <div className="mb-2 flex flex-wrap items-center gap-2 text-xs font-semibold uppercase text-stone-500">
          Admin <ChevronRight className="h-3 w-3" /> {location.pathname}
        </div>
        <h1 className="text-2xl font-bold text-leaf-dark md:text-3xl">{title}</h1>
        <p className="mt-1 max-w-3xl text-sm leading-6 text-stone-600">{subtitle}</p>
      </div>
      {action}
    </div>
  )
}
